import { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { OriginViewValueType, PanelNameValueType } from '@/lib/analytics/Avo';

interface InsightsPanelContextValue {
  panelName: PanelNameValueType;
  originView: OriginViewValueType | null | undefined;
}

const InsightsPanelContext = createContext<InsightsPanelContextValue | null>(null);

interface InsightsPanelProviderProps {
  children: ReactNode;
  panelName: PanelNameValueType;
  originView: OriginViewValueType | null | undefined;
}

export const InsightsPanelProvider = ({
  children,
  panelName,
  originView,
}: InsightsPanelProviderProps) => {
  const value = useMemo(() => ({ panelName, originView }), [panelName, originView]);

  return <InsightsPanelContext.Provider value={value}>{children}</InsightsPanelContext.Provider>;
};

export const useInsightsPanelContext = () => {
  const context = useContext(InsightsPanelContext);
  return context;
};
